// extracted by mini-css-extract-plugin
export default {"stosks_column":"styles_stosks_column__0aT2x","link_download":"styles_link_download__shMT7","main_block":"styles_main_block__zShuk","text_time":"styles_text_time__8sb61"};